var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V5C8.75 5.41421 8.41421 5.75 8 5.75C7.58579 5.75 7.25 5.41421 7.25 5V2C7.25 1.58579 7.58579 1.25 8 1.25Z",
    fill: "#23262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V5C16.75 5.41421 16.4142 5.75 16 5.75C15.5858 5.75 15.25 5.41421 15.25 5V2C15.25 1.58579 15.5858 1.25 16 1.25Z",
    fill: "#23262F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 9.08997C2.75 8.67575 3.08579 8.33997 3.5 8.33997H20.5C20.9142 8.33997 21.25 8.67575 21.25 9.08997C21.25 9.50418 20.9142 9.83997 20.5 9.83997H3.5C3.08579 9.83997 2.75 9.50418 2.75 9.08997Z",
    fill: "#23262F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7371 5.38534C4.09637 6.07535 3.75 7.11497 3.75 8.5V17C3.75 18.385 4.09637 19.4246 4.7371 20.1147C5.36848 20.7946 6.39295 21.25 8 21.25H16C17.607 21.25 18.6315 20.7946 19.2629 20.1147C19.9036 19.4246 20.25 18.385 20.25 17V8.5C20.25 7.11497 19.9036 6.07535 19.2629 5.38534C18.6315 4.70538 17.607 4.25 16 4.25H8C6.39295 4.25 5.36848 4.70538 4.7371 5.38534ZM3.6379 4.36466C4.63152 3.29462 6.10705 2.75 8 2.75H16C17.893 2.75 19.3685 3.29462 20.3621 4.36466C21.3464 5.42465 21.75 6.88503 21.75 8.5V17C21.75 18.615 21.3464 20.0754 20.3621 21.1353C19.3685 22.2054 17.893 22.75 16 22.75H8C6.10705 22.75 4.63152 22.2054 3.6379 21.1353C2.65363 20.0754 2.25 18.615 2.25 17V8.5C2.25 6.88503 2.65363 5.42465 3.6379 4.36466Z",
    fill: "#23262F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6992 13.6992C14.6992 13.1469 15.1469 12.6992 15.6992 12.6992H15.7082C16.2605 12.6992 16.7082 13.1469 16.7082 13.6992C16.7082 14.2515 16.2605 14.6992 15.7082 14.6992H15.6992C15.1469 14.6992 14.6992 14.2515 14.6992 13.6992Z",
    fill: "#23262F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6992 16.6992C14.6992 16.1469 15.1469 15.6992 15.6992 15.6992H15.7082C16.2605 15.6992 16.7082 16.1469 16.7082 16.6992C16.7082 17.2515 16.2605 17.6992 15.7082 17.6992H15.6992C15.1469 17.6992 14.6992 17.2515 14.6992 16.6992Z",
    fill: "#23262F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9961 13.6992C10.9961 13.1469 11.4438 12.6992 11.9961 12.6992H12.0051C12.5574 12.6992 13.0051 13.1469 13.0051 13.6992C13.0051 14.2515 12.5574 14.6992 12.0051 14.6992H11.9961C11.4438 14.6992 10.9961 14.2515 10.9961 13.6992Z",
    fill: "#23262F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9961 16.6992C10.9961 16.1469 11.4438 15.6992 11.9961 15.6992H12.0051C12.5574 15.6992 13.0051 16.1469 13.0051 16.6992C13.0051 17.2515 12.5574 17.6992 12.0051 17.6992H11.9961C11.4438 17.6992 10.9961 17.2515 10.9961 16.6992Z",
    fill: "#23262F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29297 13.6992C7.29297 13.1469 7.74068 12.6992 8.29297 12.6992H8.30195C8.85424 12.6992 9.30195 13.1469 9.30195 13.6992C9.30195 14.2515 8.85424 14.6992 8.30195 14.6992H8.29297C7.74068 14.6992 7.29297 14.2515 7.29297 13.6992Z",
    fill: "#23262F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29297 16.6992C7.29297 16.1469 7.74068 15.6992 8.29297 15.6992H8.30195C8.85424 15.6992 9.30195 16.1469 9.30195 16.6992C9.30195 17.2515 8.85424 17.6992 8.30195 17.6992H8.29297C7.74068 17.6992 7.29297 17.2515 7.29297 16.6992Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4c13285842cfc24beff3aa72abedd3f8.svg";
export { ForwardRef as ReactComponent };